import {
  gridGutter,
  fontSize18,
  fontSize16
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import theme from '../../../../js/shared/new-theme';

export const boxInfoRegisteredStyle = `
  display: flex;
  justify-content: space-between;
  background-color: ${theme.palette.gray[100].value};
  border-radius: 8px;
  padding: ${gridGutter}px ${gridGutter}px ${gridGutter}px;
  flex-direction: column;

  .title {
    font-weight: bold;
    margin: 0 0 4px;
  }

  .title-bf {
    font-size: 12px;
    color: ${theme.palette.gray[800].value};
    strong {
      display: block;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .resume-row {
    justify-content: space-between;
    .title{
      padding: 0 0 10px;
    }
  }

  .bank-row {
    padding-top: ${gridGutter}px;
    border-top: solid 2px ${theme.palette.gray[400].value};
    color: ${theme.palette.gray[600].value};
    flex-direction: column;

    .title{
      font-size: 16px;
      margin-right: 14px;
    }

    .bank-details {
      margin-right: 24px;
      &--edit {
        align-self: flex-start;
        &--link {
          font-size: ${fontSize16};
          color: ${theme.palette.secondary[500].value};
        }
      }

      .values{
        font-weight: bold;
        margin: 0 0 14px;
        color: ${theme.palette.gray[800].value};
      }

    }

    & > .bank-details {
      min-width: 100px;
    }
  }

  .phoneLatam-row{
    padding-top: ${gridGutter}px;
    border-top: solid 2px ${theme.palette.gray[400].value};
    flex-direction: column;

    .values{
      font-weight: bold;
      margin: 0 0 14px;
      color: ${theme.palette.gray[800].value};
    }

    .wrongValue {
      color: ${theme.palette.red[500].value}
    }
  }

  .cc-row {
    padding-top: ${gridGutter}px;
    margin-top: ${gridGutter}px;
    border-top: solid 2px ${theme.palette.gray[400].value};
    flex-direction: column;

    .title{
      margin-right: 14px;
    }

    .cc-details {
      margin-right: 24px;
      &--edit {
        align-self: flex-start;;
        &--link {
          font-size: ${fontSize16};
          color: ${theme.palette.secondary[800].value};
        }
      }
    }

    .values{
      font-weight: bold;
      margin: 0 0 14px;
      color: ${theme.palette.gray[800].value};
    }

    & > .cc-details {
      min-width: 143px;
      margin-right: 24px;
    }
  }

  .box-price--tooltip {
    margin-left: 8px;
  }
  .area {
    &-card-company {
      min-width: 150px;
    }
    &-offer-data{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 100%;
      align-content: flex-start;

      .values {
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
      }
    }
    &-infos {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 100%;
      align-content: flex-start;
    }
    &-total-expected-gain {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      min-width: 200px;
      .title {
        margin: 0;
      }
      .values {
        font-weight: bold;
        color: ${theme.palette.gray[800].value};
      }
      .box-price {
        display:flex;
        line-height: 23px;

        &--tooltip {
          margin: 4px 0 0 8px;
        }

        &--currency {
          color: ${theme.palette.gray[800].value};
          font-size: ${fontSize18};
          font-weight: bold;
        }
      }
    }
  }

  .button-fix-number {
    display: flex;
    margin-left: auto;
    padding: 14px 24px;
    background-color: #fff;
    border: 1px #1abc9c solid;
    width: auto;
    color: #1abc9c;
    font-weight: bold;
    border-radius: 4px;
  }

  .mgr-64 {
    margin-right: 64px;
  }

`;